<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content> {{ data.content }}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close (click)="onCancelClick()">
    {{ data.rejectLabel ?? 'Cancel' }}
  </button>
  <button
    mat-button
    mat-dialog-close
    cdkFocusInitial
    color="primary"
    [mat-dialog-close]="true">
    {{ data.confirmLabel ?? 'Confirm' }}
  </button>
</mat-dialog-actions>
